import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class ThemeValueService {
	private themeValue: string | undefined;

	setValue(theme: string | undefined): void {
		this.themeValue = theme;
	}

	getValue(): string | undefined {
		return this.themeValue;
	}
}
